module.exports = __webpack_public_path__ + "static/media/arrow-up.98321341.svg";